<template>
  <div>
    <el-dialog :show-close=false :visible.sync="centerDialogVisible" top="25vh"  width="445px"  center :close-on-click-modal=false :close-on-press-escape=false >
      <div class="txt">亲爱的老师，<br/>按照深圳市教科院要求，您需补全个人资料后才能正常使用教学资源平台，请先完善个人信息。</div>
      <span slot="footer" class="dialog-footer">
        <el-button class="sure-bind" type="primary" @click="toInfoDetail()">立即完善个人信息</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'CompleteInfoDialog',
  data () {
    return {
      centerDialogVisible: false
    }
  },
  methods: {
    showDialog () {
      this.centerDialogVisible = true
    },
    toInfoDetail () {
      this.centerDialogVisible = false
      this.$router.push('./information')
    }
  }
}
</script>
<style scoped>
.txt{
  text-align: left;
  padding: 0 20px;
  font-size: 16px;
  color: #333;
  line-height: 1.8;
}
.sure-bind{
  width: 200px;
  margin-bottom: 30px;
}
</style>
